import { render, staticRenderFns } from "./AepPlanRecommendation.vue?vue&type=template&id=25d4a2c2&lang=pug"
import script from "./AepPlanRecommendation.vue?vue&type=script&lang=js"
export * from "./AepPlanRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardAepCopayBlock: require('/home/docker/code/frontend/components/card/AepCopayBlock.vue').default,CardAepNetworkBlock: require('/home/docker/code/frontend/components/card/AepNetworkBlock.vue').default})
